import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InstructionsComponent } from '../instructions/instructions.component';
import { SnackService } from '../../service/snack.service';
import { AiService } from '../../service/ai.service';
import { Subscription } from 'rxjs';
import { ReportService } from '../../service/report.service';
import { UploadRaggerComponent } from './upload-ragger/upload-ragger.component';
// import { UserRagComponent } from '../user-rag/user-rag.component';
// import { ProductIdeasComponent } from '../user-rag/product-ideas/product-ideas.component';
import { InitStreamViewComponent } from '../init-stream-view/init-stream-view.component';
import { TrackService } from '../../service/track.service';

@Component({
    selector: 'app-basic-idea',
    standalone: false,
    templateUrl: './basic-idea.component.html',
    styleUrl: './basic-idea.component.scss'
})
export class BasicIdeaComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    // Injections
    fb = inject(FormBuilder)
    cd = inject(ChangeDetectorRef);
    trackService = inject(TrackService);
    dialog = inject(MatDialog);
    snack = inject(SnackService);
    aiService = inject(AiService);
    report = inject(ReportService);

    // Inputs
    @Input() thisStepCount: number = 0;
    @Input() totalStepCount: number = 0;
    @Input() stepId: any;
    @Input() streamId: any;
    @Input() roundId: any;
    @Input() step: any;
    @Input() runClosingPrompt: boolean = false;

    @ViewChild('contentContainer') contentContainer!: ElementRef<HTMLDivElement>;

    // Outputs
    @Output() nextStreamStepDisabledStatus: EventEmitter<boolean> = new EventEmitter(true);
    @Output() closingPromptReady: EventEmitter<{ "input": string, "type": string } | undefined> = new EventEmitter(undefined);

    // Variables
    loading: boolean = false;
    aiIsRunning: boolean = false;
    activeStep: number = 1;
    maxSteps: number = 3
    closingPromptCounter: number = 0
    problemFormCOntrol: any;
    userFormCOntrol: any;
    solutionFormCOntrol: any;

    // Objects
    communicationHistory: any[] = [];
    private subscriptions: Subscription = new Subscription();

    // Getter methods for reactive form values
    get problemValue(): string {
        return this.problemFormCOntrol?.value || '';
    }

    get userValue(): string {
        return this.userFormCOntrol?.value || '';
    }

    get solutionValue(): string {
        return this.solutionFormCOntrol?.value || '';
    }


    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    async ngAfterViewInit(): Promise<void> {
        this.aiService.agentId.next("flying_jhonny");
        while (this.roundId === undefined || this.roundId === null || this.roundId === "") {
            await new Promise(resolve => setTimeout(resolve, 10));
        }
        await this.loadCommunicationHistory();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["runClosingPrompt"] && changes["runClosingPrompt"].currentValue) {
            if (changes["runClosingPrompt"].currentValue === true) {
                this.startCLosingPrompt();
            }
        }
    }

    async ngOnInit() {
        this.problemFormCOntrol = this.fb.control("");
        this.userFormCOntrol = this.fb.control('');
        this.solutionFormCOntrol = this.fb.control('');

        this.aiService.modelId.next('Basic Idea');

        this.subscriptions.add(this.aiService.contentForInput.subscribe((data: any) => {
            if (data) {
                if (data.context_id !== undefined) {
                    if (data.context_id.indexOf('problem') !== -1) {
                        this.problemFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                    if (data.context_id.indexOf('user') !== -1) {
                        this.userFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                    if (data.context_id.indexOf('solution') !== -1) {
                        this.solutionFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                } else {
                    if (data.id.indexOf('PROBLEM') !== -1) {
                        this.problemFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                    if (data.id.indexOf('TARGET USER') !== -1) {
                        this.userFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                    if (data.id.indexOf('SOLUTION') !== -1) {
                        this.solutionFormCOntrol.setValue(data.text);
                        this.aiService.contentForInput.next(undefined);
                        this.cd.detectChanges();
                    }
                }
            }
        }));
    }

    async loadCommunicationHistory() {

        let res = await this.trackService.loadComHistory(this.stepId, this.roundId);

        if (res) {
            this.communicationHistory = res;
            let problem = await res.find((e: any) => e.type == 'PROBLEM')

            if (problem) {
                this.activeStep++;
                this.problemFormCOntrol.setValue(problem.content);
                this.cd.detectChanges();
            }

            let user = await res.find((e: any) => e.type == 'TARGET USER')
            if (user) {
                this.activeStep++;
                this.userFormCOntrol.setValue(user.content);
                this.cd.detectChanges();
            }

            let solution = await res.find((e: any) => e.type == 'SOLUTION')
            if (solution) {
                this.activeStep++;
                this.solutionFormCOntrol.setValue(solution.content);
                this.cd.detectChanges();
            }



            // let stepFiles = await this.streamService.trackFileResults.getValue().filter((file: any) => file.stepId === this.stepId);
            // // if (stepFiles.length > 0) {
            // //   this.nextStreamStepDisabledStatus.emit(false)
            // // }

            // Start Ai-Agent
            if (this.problemFormCOntrol.value == "" && this.userFormCOntrol.value == "" && this.solutionFormCOntrol.value == "") {

                this.loading = true;
                this.aiIsRunning = true;
                await this.aiService.defaultAiService("", "")
                this.loading = false;
                this.aiIsRunning = false;

            } else {
                let valueContent = "";
                let target = '';

                if (this.userFormCOntrol.value == "" || this.userFormCOntrol.value == "<empty string>") {
                    target = 'TARGET USER'; valueContent = this.userFormCOntrol.value;
                } else
                    if (this.solutionFormCOntrol.value == "" || this.solutionFormCOntrol.value == "<empty string>") {
                        target = 'SOLUTION'; valueContent = this.solutionFormCOntrol.value;
                    }

                let query = `
        <PROBLEM>
        ${this.problemFormCOntrol.value}
        <TARGET USER>
        ${this.userFormCOntrol.value}
        <SOLUTION>
        ${this.solutionFormCOntrol.value}

        <TASK>
        jump to task ${target}
        `;
                if (this.problemFormCOntrol.value !== "" && this.userFormCOntrol.value !== "" && this.solutionFormCOntrol.value !== "") {
                    this.aiService.showAiChat.next(false);
                    this.nextStreamStepDisabledStatus.emit(false);
                    return;
                }

                if (!valueContent || valueContent === "") {
                    this.loading = true;
                    this.aiIsRunning = true;
                    await this.aiService.defaultAiService('Basic Idea Support me: ' + target, query, true);
                    this.loading = false;
                    this.aiIsRunning = false;
                }
            }
        } else {
            let dia = this.dialog.open(InitStreamViewComponent, {
                panelClass: "full-screen",
                autoFocus: false
            });
            dia.afterClosed().subscribe(async (result) => {
                if (result == "cancel") {
                    return;
                }
                this.loading = true;
                await this.hiddenPrompt("problem", "")
                this.loading = false;
                this.startUserRag();
            });
        }
    }
    async uploadUserRag(sumaryDocument: any = undefined) {
        // let dia = this.dialog.open(UserRagComponent, {
        //   data: sumaryDocument,
        //   autoFocus: false
        // });

        // dia.afterClosed().subscribe((result) => {
        //   if (result == 'closed') {
        //     this.startUserRag();
        //   }

        //   if (result && result.summary) {

        //     let ideas = this.dialog.open(ProductIdeasComponent, {
        //       data: result,
        //       autoFocus: false
        //     });

        //     ideas.afterClosed().subscribe(async (selectedIdea: any) => {
        //       if (selectedIdea) {
        //         console.log("SELECTED IDEA", selectedIdea);

        //         this.problemFormCOntrol.value = selectedIdea.problemStatement || "";
        //         await this.nextStep('PROBLEM', this.problemFormCOntrol.value);
        //         this.userFormCOntrol.value = selectedIdea.targetUsers || "";
        //         await this.nextStep('TARGET USER', this.userFormCOntrol.value);
        //         this.solutionFormCOntrol.value = selectedIdea.solutionMechanism || "";
        //         await this.nextStep('SOLUTION', this.solutionFormCOntrol.value);

        //         this.loading = true;
        //         let input = `<USER CONTENT>
        //         ${JSON.stringify(selectedIdea)}`;
        //         await this.aiService.defaultAiService('Basic Idea Idea Extract from file', input, true);
        //         this.loading = false;
        //       } else {
        //         this.uploadUserRag(result);
        //       }
        //     });
        //   }
        // })
    }
    async startUserRag() {
        let dia = this.dialog.open(UploadRaggerComponent, {
            autoFocus: false,
            panelClass: 'small-dialog-width'
        });

        dia.afterClosed().subscribe(async (result) => {
            if (result) {
                console.log('Dialog result:', result);

                switch (result) {
                    case 'guide-me':
                        this.loading = true;
                        while (this.aiIsRunning === true) {
                            await new Promise(resolve => setTimeout(resolve, 1000));
                        }
                        await this.aiService.defaultAiService('Basic Idea problem', "Guide me step by step");
                        this.loading = false;
                        break;
                    case 'upload-paper':
                        this.uploadUserRag()
                        break;
                    default:
                        console.log('Unhandled dialog result:', result);
                }

            }
        });
    }
    async nextStep(type: string, event: any) {
        let i = await this.communicationHistory.find(l => l.type == type)

        if (!i) {
            this.communicationHistory.push({
                type,
                content: event
            });
        } else {
            this.communicationHistory.forEach((l: any) => {
                if (l.type === type) {
                    console.log('i', l);
                    l.content = event;
                }
            })
        }

        this.activeStep += 1
        if (this.activeStep > this.maxSteps) {
            this.nextStreamStepDisabledStatus.emit(false);
        }
        this.trackService.saveComHistory(this.stepId, this.roundId, this.communicationHistory);
    }
    async restartAgain() {
        // console.log(files);

        if (this.communicationHistory.length == 0) {
            this.contentContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' })
            return;
        }

        let confirmResult = await confirm('Do you really want to reset your Data? All Files and Memory-Data will be deleted.')
        if (!confirmResult) {
            return;
        }
        let files = await this.trackService.trackFiles.getValue();
        for await (let file of files) {
            if (file.roundId == this.roundId && file.stepId == this.stepId) {
                await this.trackService.deleteFileFromTrackResult(this.roundId, file.id, file.fileName)
            }
        }
        this.activeStep = 1;
        this.problemFormCOntrol.setValue("");
        this.userFormCOntrol.setValue("");
        this.solutionFormCOntrol.setValue("");
        this.report.saveReport(this.roundId, 'Reset & Start Again')
        this.nextStreamStepDisabledStatus.emit(true);
        this.closingPromptCounter = 0;
        this.communicationHistory = [];
        this.trackService.saveComHistory(this.stepId, this.roundId, this.communicationHistory);
        this.aiService.resetChat();
    }
    async startCLosingPrompt() {
        if (!this.streamId || !this.stepId) {
            this.snack.error({ error: { msg: { "headline": "Frontend Error", "text": "Stream ID or Step ID is not provided" } } });
            return;
        }
        if (this.problemFormCOntrol.value == "" || this.userFormCOntrol.value == "" || this.solutionFormCOntrol.value == "") {
            return;
        }

        let promptType = 'CLOSING_STEP_PROMPT';
        let userInput = `
    <PROBLEM>
    ${this.problemFormCOntrol.value}

    <TARGET USER>
    ${this.userFormCOntrol.value}

    <SOLUTION>
    ${this.solutionFormCOntrol.value}
    `;
        this.closingPromptReady.emit({ "input": userInput, "type": promptType });

    }
    async hiddenPrompt(name: string, event: any) {
        // runs after emit from control-field when user enters more than 2 words
        console.log('More than 2 Words', name, event);
        await this.aiService.defaultAiService('Basic Idea ' + name, event);
        return null;
    }
    async supportMe(name: string, event: any) {
        let input = "Support me with " + name;


        if (this.problemFormCOntrol.value !== '') {
            input += `
      <user input PROBLEM>
      ${this.problemFormCOntrol.value}
      `
        }
        if (this.userFormCOntrol.value !== '') {
            input += `
      <user input TARGET USER>
      ${this.userFormCOntrol.value}
      `
        }
        if (this.solutionFormCOntrol.value !== '') {
            input += `
      <user input SOLUTION>
      ${this.solutionFormCOntrol.value}
      `
        }
        console.log('Support Me triggered with:', name, input);

        this.loading = true;
        await this.aiService.defaultAiService('Basic Idea Support me: ' + name, input);
        this.loading = false;
    }
    async autofill(name: string, event: any) {
        if (!this.streamId || !this.stepId) {
            this.snack.error({ error: { msg: { "headline": "Frontend Error", "text": "Stream ID or Step ID is not provided" } } });
            return;
        }

        if (event && event !== '') {
            this.communicationHistory.push({
                type: name,
                content: event
            });
        }
        let promptType = 'FILL_OUT_ALL_PROMPT';
        let userInput = "";

        if (name == 'PROBLEM') {
            // console.log('PROBLEM clicked');
            userInput = `<PROBLEM>\n${this.problemFormCOntrol.value}`;
        }
        if (name == 'TARGET USER') {
            // console.log('TARGET USER clicked');
            userInput = `<PROBLEM>\n${this.problemFormCOntrol.value}\n\n<TARGET USER>\n${this.userFormCOntrol.value}`;
        }
        if (name == 'SOLUTION') {
            // console.log('SOLUTION clicked');
            userInput = `<PROBLEM>\n${this.problemFormCOntrol.value}\n\n<TARGET USER>\n${this.userFormCOntrol.value}\n\n<SOLUTION>\n${this.solutionFormCOntrol.value}`;
        }

        this.loading = true;
        let result = await this.aiService.getAiResponse(this.streamId, this.stepId, userInput, promptType, 0, this.roundId)
        this.loading = false;
        if (result === false) return;

        this.report.saveReport(this.roundId, 'Autofill ALl')
        this.communicationHistory = [];

        this.problemFormCOntrol.setValue(result.promptResult[0].text);
        this.nextStep('PROBLEM', result.promptResult[0].text)
        this.userFormCOntrol.setValue(result.promptResult[1].text);
        this.nextStep('TARGET USER', result.promptResult[1].text)
        this.solutionFormCOntrol.setValue(result.promptResult[2].text);
        this.nextStep('SOLUTION', result.promptResult[2].text)
        this.activeStep = 4;



    }
    async setStep(step: number) {
        this.activeStep = step;
    }
    async openInstructions() {
        let dia = await this.dialog.open(InstructionsComponent, {
            data: { for: 'basicIdea' },
            width: '500px'
        });

        dia.afterClosed().subscribe((result) => { })
    }

}
